export const EXPERIMENTS_PARAM_SEARCH_KEY = 'name';
export const EXPERIMENTS_PARAM_PAGENO_KEY = 'pageNo';
export const EXPERIMENTS_PARAM_PAGESIZE_KEY = 'pageSize';
export const EXPERIMENTS_PARAM_DATES = 'dates';
export const EXPERIMENTS_PARAM_START = 'start';
export const EXPERIMENTS_PARAM_END = 'end';
export const EXPERIMENTS_VIEW = 'view';
export const EXPERIMENTS_VIEW_CALENDAR = 'calendar';
export const EXPERIMENTS_TAB_VIEW = 'tab';
export const EXPERIMENTS_PARAM_DEFAULT_OWNER = 'defaultOwner';
export const EXPERIMENTS_PARAM_OWNER = 'owner';
